.timelineSettingsContainer {
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	gap: var(--jpo-common-base-spacing) calc(4 * var(--jpo-common-base-spacing));
}

.timelineSettingsContainerOld {
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	gap: var(--jpo-common-base-spacing) calc(4 * var(--jpo-common-base-spacing));
}

.timelineSettingsField {
	margin-top: -6px;
	gap: 2px;
}

.timelineWidthContainer {
	display: flex;
	align-items: center;
	gap: 10px;
}

.timelineWidthContainerOld {
	display: flex;
	align-items: center;
}

.timelineSettingsFieldset {
	border: none;
	margin-bottom: -2px;
	margin-top: 7px;
}

.timelineSettingsLegend {
	padding: 0;
	font-size: 12px;
	font-weight: var(--ds-font-weight-semibold, 600);
	margin-bottom: 4px;
	color: var(--ds-text-subtle, #6b778c);
}

.iconButton {
	border: 1px solid var(--ds-border, var(--adg3-color-N40)) !important;
	border-radius: 0px !important;
}

.leftButton {
	border-radius: 3px 0px 0px 3px !important;
}

.rightButton {
	border-radius: 0px 3px 3px 0px !important;
}

.smallIcon {
	& svg {
		width: 22px;
		height: 13px;
	}
}

.mediumIcon {
	& svg {
		width: 22px;
		height: 17px;
	}
}

.largeIcon {
	& svg {
		width: 22px;
		height: 20px;
	}
}

.customTextBoxContainer {
	align-items: center;
	caret-color: var(--ds-icon-subtle, var(--adg3-color-N500));
	display: flex;
	margin-left: var(--jpo-common-base-spacing);
}

.customTextBoxContainerLabel {
	margin-left: 5px;
	color: var(--ds-text-subtle, var(--adg3-color-N400));
	font-size: 16px;
}
